import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Input,
  SimpleChanges,
} from '@angular/core'
import { ChartOptions, ChartType } from 'chart.js'
import { Utils } from '../../utils'
import * as pluginDataLabels from 'chartjs-plugin-datalabels'

@Component({
  selector: 'app-chart-card',
  templateUrl: './chart-card.component.html',
  styleUrl: './chart-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartCardComponent {
  @Input() chartData: number[]
  @Input() chartLabels: string[]
  @Input() chartTitle: string
  @Input() colorSet: 1 | 2 | 3 = 1
  @Input() unit: string
  @Input() type: 'string' | 'number'

  public doughnutChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          const dataArr = ctx.chart.data.datasets[0].data as number[]
          const sum = dataArr.reduce((acc, val) => acc + val, 0)
          const percentage = ((value / sum) * 100).toFixed(2) + '%'
          return percentage
        },
        color: 'black',
      },
    },
  }
  public chartType: ChartType = 'doughnut'
  public doughnutChartColors: any[] = [{ backgroundColor: [] }]
  public doughnutChartLegend = false
  public doughnutChartPlugins = [pluginDataLabels]

  getColor(i: number) {
    return Utils.getColor(
      this.colorSet === 1 ? i : this.colorSet === 2 ? i + 2 : i + 7
    )
  }

  constructor() {}

  ngOnInit(): void {}

  showChart = () => this.chartData.some(item => item)

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.chartData?.currentValue?.length) {
      this.doughnutChartColors[0].backgroundColor = this.chartData.map(
        (_item, i) => this.getColor(i)
      )
    }
  }
}
